import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { formatImageUrl } from '../../shared/utils/formatImageUrl';
import { dateToString } from '../../shared/utils/parseDate.js';
import { Pagination } from '../../features/Pagination/index.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const NewsPage = () => {
  const [news, setNews] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const location = useLocation();

  const getData = (count = 10, offset = 0) => {
    apiRequests.news.get(count, offset).then((res) => setNews(res));
  };

  useEffect(() => {
    // getData()
  }, []);

  const handleDelete = async (id) => {
    await apiRequests.news.delete(id).then(() =>
      setNews((prev) => ({
        totalCount: prev.totalCount,
        items: prev.items.filter((i) => i.id !== id),
      })),
    );
  };

  const handleSearch = () => {
    if (searchValue === '') {
      getData();
    } else {
      apiRequests.news.getFiltered(searchValue).then((res) => setNews(res));
    }
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск новостей..."
        createLink={`${location.pathname}/create`}
      />

      <div className="mb-3">
        {news.items?.length === 0 ? (
          <p className="text-center">По вашему запросу ничего не найдено</p>
        ) : (
          news.items?.map((item) => (
            <EntityCard
              key={item.id}
              image={formatImageUrl(item.imgPath)}
              title={item.title}
              fields={[
                { label: 'Создано', value: dateToString(item.createdAt) },
              ]}
              editLink={`${location.pathname}/${item.id}`}
              localizationLink={`${location.pathname}/${item.id}/localization`}
              onDelete={() => handleDelete(item.id)}
            />
          ))
        )}
      </div>

      <Pagination
        count={news.totalCount}
        itemsPerPage={10}
        onChange={(page) => getData(10, 10 * page)}
      />
    </>
  );
};

export default NewsPage;
